// extracted by mini-css-extract-plugin
export default {"videoCont":"videoPlayer_videoCont__Cmx5d"};